<template>
  <div :class="classes">
    <my-category
      v-for="category in categories"
      :key="category.id"
      :id="category.id"
      :default="category.default"
      :disabled="category.disabled"
      :label="category.label"
      :groups="category.groups"
      v-model="categoryStates[category.id]"
    />
  </div>
</template>



<script>
import MyCategory from './GnaviCategory';



export default {
  name: 'dn-gnavi-inner',

  props: {
    device: {
      type: String,
      required: true,
    },
    dumped: Boolean,
  },

  components: {
    MyCategory,
  },

  data() {
    return {
      categoryStates: {},
    }
  },

  computed: {
    classes() {
      return {
        'dn-gnavi__inner': true,
        'dn-gnavi__inner--dumped': this.dumped,
        [`dn-gnavi__inner--${this.device}`]: true,
      }
    },
    categories() {
      const categories = this.$store.getters['navigation/gnaviCategories'];
      const categoryStates = {};
      for (const category of categories) {
        if (this.categoryStates[category.id] === undefined) {
          categoryStates[category.id] = category.default || (!category.disabled && !!this.dumped || !!category.matched);
        } else {
          categoryStates[category.id] = this.categoryStates[category.id];
        }
      }

      this.$set(this, 'categoryStates', categoryStates);

      if (!this.$store.getters['config/isManabi']) {
      // 現在のURLにマッチしたカテゴリを上位表示したければ、、、
      categories.sort((a, b) => {
        if (a.matched) return -1;
        if (b.matched) return 1;
        return 0;
      });
      }

      return categories;
    },
  },
}
</script>



// WEBPACK FOOTER //
// GnaviInner.vue?a6e0cb68